import React, { useState, useEffect } from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { useSelector } from "react-redux";
import ChartDataLabels from "chartjs-plugin-datalabels";
import axiosInstance from '../../../../ReusableComponents/Axios';
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const StackedChart = (props) => {
  const labels = [];
  const sections = {};
  const [Participation, SetParticipation] = useState([]);
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
    const USYear = useSelector((state) => state.SelecYearData.SYear);
  const ParticipationAssessment = async () => {
    SetParticipation();
    try {
      const res = await axiosInstance.get(`/Principal/GetSchoolAssessmentWiseDifficultyPercenatge?SchoolId=${props?.SId}&Grade=${props.Grade}&AssessmentType=${props.Atype}&Year=${USYear?.value}`);
      if (res.data[0].assessmentTypeName) {
        const Subject = res.data.reduce((acc, item) => {
          (acc[item.subjectName] = acc[item.subjectName] || []).push(item)
          return acc
        }, {})
        SetParticipation(Subject);
      }
      else { SetParticipation(process.env.REACT_APP_NODATAFOUND_Participated); }
    }
    catch (err) {
      console.log(err)
    }
  };
  useEffect(() => { ParticipationAssessment(); }, [USYear, props.Grade, props.Atype ]);

  if (Participation?.[props.SubjectName]?.[0]?.assessmentTypeName) {
    Participation[props.SubjectName].forEach(item => {
      const labelName = `${item.assessmentTypeName} (${item.testStartDateTime})`;
      if (!labels.includes(labelName)) { labels.push(labelName); }
      if (!sections[item.difficultyLevel]) {
        sections[item.difficultyLevel] = Array(labels.length).fill(null);
      }
    });
    // // Populate section arrays with data
    Participation[props.SubjectName].forEach(item => {
      const labelName = `${item.assessmentTypeName} (${item.testStartDateTime})`;
      const index = labels.indexOf(labelName);
      sections[item.difficultyLevel][index] = item.percentage;
    });

  }

  const options = {
    plugins: {
      legend: { position: 'bottom', labels: { usePointStyle: true, }, },
      datalabels: {
        anchor: "end",
        align: "end",
        offset: -5,
        formatter: (value) => {
          return value;
        },
        font: {
          size: 12,
          weight: "bold",
        },
      },
    },
    responsive: true,
    scales: {
      x: { title: { display: true, text: 'Assessment Date' }, grid: { display: false, }, barPercentage: 0.5, categoryPercentage: 0.8, },
      y: { max: 100, title: { display: true, text: '% Participation' } },
    },
  };

  const datasets = Object.keys(sections).map(section => ({
    label: section,
    data: sections[section],
    backgroundColor: {
      "High (Challenge)": '#3DA663',
      "Low (Content)": '#7C60BC',
      "Medium (Concept)": '#3B9ED7',
      D: '#F7C66A',
      X: '#A63D95',
    }[section] || '#000',
    maxBarThickness: 20,
    barThickness: 25
  }));
  const data = {
    labels: labels,
    datasets: datasets
  };
  return (
    <>
      {Participation?.[props.SubjectName]?.[0]?.assessmentTypeName ? <Bar options={options} data={data} plugins={[ChartDataLabels]} ref={props.Ref}/> :
        <div className="ErrorMessage">{process.env.REACT_APP_NODATAFOUND_Participated}</div>}
    </>
  )
};
export default StackedChart;